
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    WeiXinPay({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Transaction/WeiXinPay',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
